import React from 'react';
import { Row, Col } from 'antd';
import { formatarDataCorrida } from '../../../helpers/formatarDataFila';

import { Indicador } from './Indicador';

export function ColButtom({ loading = false, data }) {
  const tamanhoIndicadorPrimeiraColuna = data?.quantidadeSolicErroEnvioFornecedorCriminal > 0 ? 3 : 4;

  return (
    <Row
      style={{
        marginTop: 16,
      }}
    >
      <Col span={tamanhoIndicadorPrimeiraColuna} style={{ paddingRight: 8 }}>
        <Indicador
          titulo={data?.quantidadeSolicAguardandoFornecedorCriminal || 0}
          subTitulo={formatarDataCorrida(
            data?.tempoMaximoSolicAguardandoFornecedorCriminal || '00:00:00'
          )}
          descricao="Solicitações com fornecedor (Criminal)"
          isLoading={loading}
        />
      </Col>
      {
        data?.quantidadeSolicErroEnvioFornecedorCriminal > 0 &&
        <Col span={tamanhoIndicadorPrimeiraColuna} style={{ paddingRight: 8 }}>
          <Indicador
            titulo={data?.quantidadeSolicErroEnvioFornecedorCriminal || 0}
            subTitulo="Erro de integração"
            descricao="Fornecedor (Criminal)"
            corTitulo="#D42929"
            isLoading={loading}
          />
        </Col>
      }
      <Col span={tamanhoIndicadorPrimeiraColuna} style={{ padding: '0 8px' }}>
        <Indicador
          titulo={data?.quantidadeSolicAguardandoFornecedor || 0}
          subTitulo={formatarDataCorrida(
            data?.tempoMaximoSolicAguardandoFornecedor || '00:00:00'
          )}
          descricao="Solicitações com fornecedor (BOT)"
          isLoading={loading}
        />
      </Col>
      <Col span={tamanhoIndicadorPrimeiraColuna} style={{ padding: '0 8px' }}>
        <Indicador
          titulo={data?.quantidadeSolicitacaoAguardandoAtendimentoInterno || 0}
          subTitulo={formatarDataCorrida(
            data?.tempoMaximoSolicitacaoAguardandoAtendimentoInterno ||
            '00:00:00'
          )}
          descricao="Solicitações na fila"
          isLoading={loading}
        />
      </Col>
      <Col span={4} style={{ padding: '0 8px' }}>
        <Indicador
          titulo={data?.quantidadeSolicicitacoesNaoFinalizadas || 0}
          subTitulo={formatarDataCorrida(
            data?.maiorTempoNaoFinalizado ||
            '00:00:00'
          )}
          descricao="Solicitações não finalizadas"
          isLoading={loading}
        />
      </Col>
      <Col span={4} style={{ padding: '0 8px' }}>
        <Indicador
          titulo={data?.atendimentoEmAndamento}
          subTitulo={formatarDataCorrida(
            data?.tempoMaxAtendimento || '00:00:00'
          )}
          descricao="Atendimentos em andamento"
          isLoading={loading}
        />
      </Col>
      <Col span={4} style={{ paddingLeft: 8 }}>
        <Indicador
          titulo={data?.usuariosAguardando}
          subTitulo={formatarDataCorrida(
            data?.tempoMaximoUsuarioAguardando || '00:00:00'
          )}
          descricao="Usuários aguardando"
          isLoading={loading}
        />
      </Col>
    </Row>
  );
}
